var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReuseDark6 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2506 13.5004C22.2489 15.0912 21.6162 16.6163 20.4913 17.7411C19.3665 18.866 17.8414 19.4987 16.2506 19.5004H8.00059C7.80168 19.5004 7.61091 19.4214 7.47026 19.2807C7.32961 19.1401 7.25059 18.9493 7.25059 18.7504C7.25059 18.5515 7.32961 18.3607 7.47026 18.2201C7.61091 18.0794 7.80168 18.0004 8.00059 18.0004H16.2506C17.4441 18.0004 18.5887 17.5263 19.4326 16.6824C20.2765 15.8385 20.7506 14.6939 20.7506 13.5004C20.7506 12.3069 20.2765 11.1624 19.4326 10.3184C18.5887 9.47452 17.4441 9.00042 16.2506 9.00042H5.3109L8.53122 12.2198C8.67195 12.3605 8.75101 12.5514 8.75101 12.7504C8.75101 12.9494 8.67195 13.1403 8.53122 13.281C8.39048 13.4218 8.19961 13.5008 8.00059 13.5008C7.80157 13.5008 7.6107 13.4218 7.46996 13.281L2.96996 8.78104C2.90023 8.71139 2.84491 8.62867 2.80717 8.53762C2.76943 8.44657 2.75 8.34898 2.75 8.25042C2.75 8.15186 2.76943 8.05426 2.80717 7.96321C2.84491 7.87216 2.90023 7.78945 2.96996 7.71979L7.46996 3.21979C7.6107 3.07906 7.80157 3 8.00059 3C8.19961 3 8.39048 3.07906 8.53121 3.21979C8.67195 3.36052 8.75101 3.55139 8.75101 3.75042C8.75101 3.94944 8.67195 4.14031 8.53122 4.28104L5.3109 7.50042H16.2506C17.8414 7.50215 19.3665 8.13485 20.4913 9.2597C21.6162 10.3845 22.2489 11.9097 22.2506 13.5004Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReuseDark6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reuse-dark6.0d1d2fee8a284171d52cd89f8768e865.svg";